module.exports = __webpack_public_path__ + "img/系统架构.93527882.jpg";